import DisplayField from "../../../Components/DisplayField";
import { handleDownloadS3 } from "../../../../../utils/s3";
import HelpTextIcon from "../../../Components/InformationIcon";

function PyramidStepOne({ configuration, activateExtension }) {
    return (
        <div>
            <h3 className="text-2xl font-semibold mb-8">
                Steg 1 -{" "}
                <span className="text-lg font-medium text-accent">
                    Installation
                </span>
            </h3>
            <div className="flex items-start">
                <div className="flex flex-col space-y-8 w-3/4">
                    <label className="block font-medium">
                        Följ stegen nedan för att ansluta till Pyramid:
                    </label>
                    <ul className="text-md font-medium list-decimal list-outside pl-6 space-y-4">
                        <div className="flex flex-col items-start">
                            <li>
                                Ladda ner installationspaketet genom att klicka
                                på länken nedan.
                                <br />
                                Zip-filen innehåller både Zendr-integrationen
                                som ska installeras i Pyramid och en manual med
                                instruktioner för installation och användning.
                            </li>
                            <a
                                onClick={() =>
                                    handleDownloadS3({
                                        url: `${
                                            process.env.REACT_APP_API_URL
                                        }/api/s3/integration?objectKey=${encodeURIComponent(
                                            `pyramid/pyramid_installation_${process.env.REACT_APP_PYRAMID_LATEST_VERSION}.zip`,
                                        )}`,
                                        desiredFileName: `pyramid_installation_${process.env.REACT_APP_PYRAMID_LATEST_VERSION}.zip`,
                                    })
                                }
                            >
                                <p className="text-blue-700 cursor-pointer underline">
                                    Ladda ner Pyramid-installation.zip
                                </p>
                            </a>
                        </div>

                        <li>Aktivera integrationen</li>
                        <div>
                            {!configuration.identifier ? (
                                <div className="mt-2">
                                    <p>
                                        För att generera en API-nyckel som krävs
                                        vid installationen, aktivera
                                        integrationen genom att klicka på
                                        knappen nedan:
                                    </p>
                                    <button
                                        className="c-button c-button--raised mt-4 w-60"
                                        onClick={activateExtension}
                                    >
                                        Aktivera Integration
                                    </button>
                                </div>
                            ) : (
                                <div className="mt-2 w-2/3">
                                    <div className="flex items-start">
                                        <p>Här är er API-nyckel:</p>
                                        <HelpTextIcon infoText="API-nyckeln används för att autentisera integrationen och måste skickas tillsammans med zip-filen till er Pyramid-partner." />
                                    </div>

                                    <DisplayField
                                        value={configuration.identifier}
                                        copyToClipboard={true}
                                    />
                                </div>
                            )}
                        </div>

                        <li>
                            Skicka den nedladdade zip-filen tillsammans med
                            API-nyckeln till er Pyramid-partner.
                            <br />
                            Partnern ska installera Zendr-integrationen i
                            Pyramid enligt instruktionerna i manualen.
                        </li>
                        <li>
                            Läs den medföljande manualen för att förstå hur
                            ordrar förs över från Pyramid till Zendr,
                            <br />
                            samt hur uppdaterad trackinginformation, priser m.m.
                            skickas tillbaka till Pyramid.
                        </li>
                        <li>
                            När alla ovanstående steg är genomförda kan slutföra
                            integrationen nedan.
                        </li>
                    </ul>
                    <div className="p-4">
                        <label className="block font-medium">Kostnad:</label>
                        <p>
                            Integrationen med Pyramid är kostnadsfri de första
                            30 dagarna,
                            <br />
                            därefter tillkommer en kostnad på 299 kr per månad.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PyramidStepOne;
